jQuery(function() {
  initPasswordConfirmation();
  convertReviewsDates();
  
  adjustRewardPageHerostarsHeight();
  jQuery(window).on('resize', function(){
	adjustRewardPageHerostarsHeight();
  })
});


function initPasswordConfirmation() {
  jQuery('form#create_customer').submit(function(e) {
    if ( jQuery('#password').val() === jQuery('#password-confirm').val()) {
      jQuery('form#create_customer').submit();
    } else {
      jQuery('.password-match').fadeIn("slow");
      e.preventDefault(); // stops our form from submitting
    }
  });
}

function convertReviewsDates() {
  jQuery('.reviews-card .date').each(function() {
    var dateHolder = jQuery(this);
    var date = new Date(dateHolder.text());
    var timeAgo = timeSince(date);
    dateHolder.text(timeAgo+' ago');
  });
}

function timeSince(date) {

  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = Math.floor(seconds / 31536000);

  if (interval > 1) {
    return interval + " years";
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return interval + " months";
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return interval + " days";
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return interval + " hours";
  }
  interval = Math.floor(seconds / 60);
  if (interval > 1) {
    return interval + " minutes";
  }
  return Math.floor(seconds) + " seconds";
 
}

function adjustRewardPageHerostarsHeight(){
  if(jQuery(window).width() < 768 ) {
	var imageHeight = jQuery('#one .mobile-bg-image').height();
    jQuery('.star-bg.bg1').height(imageHeight);
  } else {
    jQuery('.star-bg.bg1').removeAttr('style');
  }
}